// extracted by extract-css-chunks-webpack-plugin
module.exports = {"breakpoint-sm-max":"767px","breakpoint-md-min":"768px","breakpoint-md-max":"991px","breakpoint-lg-min":"992px","breakpoint-lg-max":"1199px","breakpoint-xl-min":"1200px"};